import { Selectbutton } from '@/shared/ui/Selectbutton'
import { useCommonCodes } from '@/shared/lib/codes'
import type { OrgNewDraft } from '@/public/features/org/types'

export function StepCardScope({ draft }: { draft: OrgNewDraft }) {
  const areas = useCommonCodes('service_area')
  const costs = useCommonCodes('cost_type')
  const pilots = useCommonCodes('pilot_available')

  return (
    <>
      <ScopeSection
        title="제공 가능한 지역은 어디인가요?"
        desc="제공 가능한 지역을 하나 선택해 주세요."
      >
        {(areas.data ?? []).map((a) => (
          <Selectbutton
            key={a.code}
            size="lg"
            label={a.label}
            isOn={draft.cardAreaCodes[0] === a.code}
            onSelect={() => draft.selectCardArea(a.code)}
          />
        ))}
      </ScopeSection>

      <ScopeSection title="이용 비용을 선택해 주세요.">
        {(costs.data ?? []).map((c) => (
          <Selectbutton
            key={c.code}
            size="lg"
            label={c.label}
            isOn={draft.cardCostType === c.code}
            onSelect={() => draft.selectCardCost(c.code)}
          />
        ))}
      </ScopeSection>

      <ScopeSection title="실증(시범사업) 참여 가능 여부를 선택해 주세요.">
        {(pilots.data ?? []).map((p) => (
          <Selectbutton
            key={p.code}
            size="lg"
            label={p.label}
            isOn={draft.cardPilot === p.code}
            onSelect={() => draft.selectCardPilot(p.code)}
          />
        ))}
      </ScopeSection>
    </>
  )
}
function ScopeSection({
  title,
  desc,
  children,
}: {
  title: string
  desc?: string
  children: React.ReactNode[]
}) {
  return (
    <section className="flex flex-col gap-[22px]">
      <div className="flex flex-col gap-[5px]">
        <p className="m-0 text-headline-xs font-normal tracking-[-0.1px] text-black-800">{title}</p>
        {desc !== undefined ? (
          <p className="m-0 text-body-md font-normal text-black-200">{desc}</p>
        ) : null}
      </div>
      <div className="grid grid-cols-2 gap-3 [&>.ui-selectbutton]:w-full [&>.ui-selectbutton]:whitespace-nowrap">
        {children}
      </div>
    </section>
  )
}
